/* eslint-disable camelcase */
import BigNumber from 'bignumber.js';

import { KeyValuePairs, SelectOptions } from '../elements/formElements/Select';

export function getLabelFromName(name: string) {
    return name.charAt(0).toUpperCase() + name.replace(/id$/, 'ID').slice(1).replace(/_/g, ' ').replace(/\./g, ' - ');
}

export function formatWithKey(options: SelectOptions) {
    const resultOptions = {};

    Object.entries(options).forEach(([key, value]) => {
        resultOptions[key] = `[${key}] ${value}`;
    });

    return resultOptions as SelectOptions;
}

type CreateOptionsFilter<T> = (item: T) => [string | number, string | number];

const optionsDefaultFilter = (item: { id: number; name: string }) => [item.id, item.name];

export function createOptions<T>(array: T[], callbackFilter: CreateOptionsFilter<T> = null) {
    const options = {};

    array.map(callbackFilter ?? ((optionsDefaultFilter as unknown) as CreateOptionsFilter<T>)).forEach((tuple) => {
        [, options[tuple[0]]] = tuple;
    });

    return options as SelectOptions;
}

export function roundNumber(value: number, decimals: number): number {
    return +parseFloat(`${value}`).toFixed(decimals);
}

export function roundPrice(value: number): number {
    // We use BigNumber to properly make float operations
    return new BigNumber(value).decimalPlaces(2, BigNumber.ROUND_HALF_UP).toNumber();
}

type TranslationBaseArticle = Readonly<{
    translation_id: number;
    title: string;
    slug: string;
    language_id: number;
}>;

export function formatArticleTranslations(options: TranslationBaseArticle[]): KeyValuePairs {
    return options.map((article) => [
        article.translation_id,
        `${article.title} / ${article.slug} (${article.translation_id})`,
    ]);
}

export function createOptionsFromEnum<T extends object>(enumObject: T): SelectOptions {
    return Object.values(enumObject).reduce((a, v) => ({ ...a, [v]: getLabelFromName(v) }), {});
}
